import React from "react";
import Reveal from "./Reveal";

export function CtaBand() {
  return (
    <section className="cta-band">
      <Reveal as="div" className="wrap">
        <h2>Ready to finish your PhD on time?</h2>
        <p>Chat with our experts instantly on WhatsApp — no waiting, no forms.</p>
        <a
          className="btn"
          style={{ background: "#221604", color: "#F3D9A6" }}
          href="https://wa.me/919058585894?text=Hello%2C%20I%20am%20interested%20in%20your%20research%20services.%20Please%20guide%20me."
          target="_blank"
          rel="noopener noreferrer"
        >
          💬 WhatsApp Us Now
        </a>
      </Reveal>
    </section>
  );
}

export function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <div className="foot-logo">Infinity Research Work</div>
            <p style={{ fontSize: ".9rem" }}>
              Empowering PhD scholars with expert research guidance.
              Solutions beyond limits — from topic selection to publication.
            </p>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Topic Selection</a></li>
              <li><a href="#services">Synopsis</a></li>
              <li><a href="#services">Research Proposal</a></li>
              <li><a href="#services">Thesis Writing</a></li>
              <li><a href="#services">Dissertation Writing</a></li>
              <li><a href="#services">Bibliometric Analysis</a></li>
              <li><a href="#services">Proofreading & Editing</a></li>
            </ul>
          </div>
          <div>
            <h4>Contact</h4>
            <ul>
              <li>📧 support@infinityresearchwork.com</li>
              <li>📞 +91-9058585894</li>
              <li>📍 Sadar Bazar, Agra — 282001</li>
              <li>🕛 Mon–Sat, 10:00 AM – 7:00 PM</li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 Infinity Research Work. All rights reserved.</span>
          <span>Built with care for scholars everywhere.</span>
        </div>
      </div>

      <a
        className="wa-float"
        href="https://wa.me/919058585894"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        💬
      </a>
    </footer>
  );
}
